import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  EParamChannelTypeGlobal,
  ETimeBucketType,
  EReportingTimeWindow,
  IReportingKeywordsChartResponse,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDAKeywordsReportChartFilters,
  TPPAdvertiserId,
  TSPKeywordsReportChartFilters,
} from '../models/types'
import { coreAPIV3 } from '../services/coreAPIV3'

export default function useGetAdvertiserReportingKeywordsChartV3({
  advertiserId,
  retailerId,
  campaignId,
  adGroupId,
  channelType,
  timeWindow,
  startDate,
  endDate,
  tzZone,
  aggregationType,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & (TSPKeywordsReportChartFilters | TDAKeywordsReportChartFilters) &
  TPPAdvertiserId): UseQueryResult<
  AxiosResponse<IReportingKeywordsChartResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getAdvertiserReportingKeywordsChart_${channelType}_${advertiserId}_${retailerId}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate, channelType }],
    () => {
      return coreAPIV3.advertiserReporting().getAdvertiserKeywordsReportChart(
        advertiserId,
        generateCorrelationId(),
        retailerId,
        campaignId,
        adGroupId,
        channelType as EParamChannelTypeGlobal,
        timeWindow as unknown as EReportingTimeWindow,
        startDate,
        endDate,
        tzZone || getTimezone(),
        aggregationType as ETimeBucketType,
        filterBy,
        filterOperation,
        filterValue,
        name,
        // @ts-expect-error: fix in PORT-2535
        status
      )
    },
    { suspense, enabled }
  )
}
